// #region Builders & Mapeadores
export function buildComissao(partial = {}) {
  return {
    id: partial.id ?? null,
    funcionario_id: partial.funcionario_id ?? null,
    venda_id: partial.venda_id ?? null,
    data_competencia: partial.data_competencia || new Date().toISOString().slice(0, 10),
    valor: Number(partial.valor || 0),
    pago: !!partial.pago,
  };
}

export function comissaoFromBackend(dto = {}) {
  return buildComissao(dto);
}

export function comissaoToJSON(c) {
  return { ...c };
}
// #endregion

// #region Helpers de agregação
export function computeStats(comissoes = []) {
  const total = comissoes.length;
  let pagas = 0;
  let pendentes = 0;
  let valorPago = 0;
  let valorPendente = 0;

  comissoes.forEach(c => {
    if (c.pago) {
      pagas++;
      valorPago += c.valor || 0;
    } else {
      pendentes++;
      valorPendente += c.valor || 0;
    }
  });

  return { total, pagas, pendentes, valorPago, valorPendente };
}
// #endregion
